import React, { useState } from "react";
import styles from "./RsvpGuestTable.module.css";
import { Col, Layout } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import Rsvp from "../../../../assets/rsvp9.png";
import ModelImage from "../../../../assets/modelscreen.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { BiSolidChevronRightCircle } from "react-icons/bi";

import Modal from "../../../../components/modal/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Rsvp9 = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  return (
    <>
      <div className={styles.mainContainer}>
        <Header
          mainHeader={styles.headerColor}
          isProfile={true}
          title={"RSVP"}
          style={{ padding: 0, background: "var(--white-color)", height: 85 }}
          onBackClick={() => navigate(-1)}
        />
        <div className={styles.mainDiv}>
          <div className={styles.innerDiv}>
            <div className={styles.innerDiv2}>
              <TextComponent textClass={styles.title} text="Table" />
              <TextComponent
                textClass={styles.text}
                text={rsvpData?.table_name}
              />
              <div className={styles.row}>
                <TextComponent textClass={styles.text1} text="Table Overview" />
                <svg
                  onClick={() => {
                    setIsModalVisible(true);
                  }}
                  className={styles.svg}
                  viewBox="0 0 64 65"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="32"
                    cy="32.3096"
                    r="32"
                    fill="var(--primary-color)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M49.7778 45.6104V18.417C49.7778 16.2804 48.0296 14.5322 45.893 14.5322H18.6996C16.563 14.5322 14.8148 16.2804 14.8148 18.417V45.6104C14.8148 47.747 16.563 49.4952 18.6996 49.4952H45.893C48.0296 49.4952 49.7778 47.747 49.7778 45.6104ZM25.4979 34.9273L30.3539 40.7544L37.1523 32.0137L45.893 43.668H18.6996L25.4979 34.9273Z"
                    fill="var(--white-color)"
                  />
                </svg>
              </div>
              <div className={styles.footer}>
                <BiSolidChevronRightCircle
                  className={styles.con1}
                  size={30}
                  onClick={() =>
                    navigate("/rsvp/rsvpGuestMeal", { state: state })
                  }
                />
              </div>
            </div>
          </div>
          <div className={styles.imgContainer}>
            <img className={styles.innerImg} src={Rsvp} />
          </div>
        </div>
      </div>
      <Modal
        setIsModalOpen={setIsModalVisible}
        closable={true}
        className={styles.model}
        contentClass={styles.modalContentent}
        isModalOpen={isModalVisible}
        pinkBg={true}
      >
        <TextComponent textClass={styles.text} text="Event Room" />
        <div className={styles.imgCont}>
          <img
            className={styles.modelImage}
            src={rsvpData?.venue_image ? rsvpData?.venue_image : ModelImage}
          />
        </div>
      </Modal>
    </>
  );
};

export default Rsvp9;
